import React from 'react'
import SavingImg1 from '../../Images/SavingImg/FutureSaving.jpg'
import SideNav from '../Navigation/SideNav'
import Aos from 'aos'

const FutureSaving = () => {

    Aos.init({
        duration: 1500,
        once: false,
        mirror: false,
        easing: 'ease-in-out-sine'
    })

    return (
        <>

            <div className='main'>
                <div className='left-fixed'></div>
                <div className='d-body'>
                    <div className='d-body-nav' data-aos='fade-right'>
                        <SideNav />
                    </div>
                    <div className='d-body-main' data-aos='fade-right'>
                        <div className='saving-body-top'>
                            <h2>भविष्य बचत</h2>
                        </div>
                        <div className='saving-body'>
                            <div className='saving-main'>
                                <h3>विशेषताहरू :</h3>
                                <p>
                                    <ul>
                                        <li>सस्था र सदस्यको सम्झौताबाट मात्र बचत गर्न शुरु गरिने ।</li>
                                        <li>बचत शुरु भए देखि अवधि पूरा नभएसम्म एकै दरमा बचत गर्नुपर्ने ।</li>
                                        <li>रु.१०० ले भाग जाने अंकमा बचतकर्ता आफैले बचतको दर तोक्नु पर्ने ।</li>
                                        <li>कुनै महिना बचत गर्न छुटाएमा १०% बचत थप गरी बचत बुझाउनु पर्ने ।</li>
                                        <li>सम्झौता पूरा भएपछि बचतको दुई गूणा हुन आउने एकमुष्ठ रकम उपलब्ध गराउन सकिने ।</li>
                                        <li>सम्झौताभन्दा अगावै बचत फिर्ता गर्नु पर्ने अवस्था आएमा ऐच्छिक बचत सरह ब्याज प्रदान गरी प्राप्त ब्याजको १० प्रतिशत खाता बन्दि शुल्क कटाई बचत फिर्ता गरिने ।</li>
                                        <li>सम्झौता अवधि अगावै ८ वर्ष पूरा भई बचत फिर्ता गर्नु पर्ने अवस्था आएमा डेढा हुन आउने रकम सहित बचत फिर्ता गरिने ।</li>
                                        <li>उत्कृष्ट बचत कर्तालाई पुरस्कार तथा सम्मान प्रदान गरिने ।</li>
                                    </ul>
                                </p>
                            </div>
                            <div className='savingimg'>
                                <img src={SavingImg1} alt='saving-1' />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='right-fixed'></div>
            </div>
        </>
    )
}

export default FutureSaving